import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, DropdownButtonItem } from '@helix/dropdown-button';

const HelixDropdown = ({ options, currentValue, onChange, isDisabled=false }) => {
    const currentOption = options.find(o => o.value === currentValue);

    return (
        <>            
            <DropdownButton                
                label={currentOption?.label}
                value={currentOption?.value}
                removeSplit={true}
                disabled={isDisabled}
                size='small'
            >
                {options?.map((option, index) => {
                    return (
                        <DropdownButtonItem
                            id={option?.value}
                            key={index}
                            onClick={({ id }) => onChange(id)}
                            textLabel={option.label}
                            value={option.value}
                        >
                            {option.label}
                        </DropdownButtonItem>
                    )
                })}
            </DropdownButton>
        </>
    );
};

export default HelixDropdown;

HelixDropdown.propTypes = {
    currentValue: PropTypes.string,
    isDisabled: PropTypes.bool,
    options: PropTypes.array,
    onChange: PropTypes.func,
};
